const config = {
    apiBaseUrl: process.env.APIBASEURL, // Our application base API URL
    rcApiBaseUrl: process.env.RINGCENTRAL_API_BASE_URL, // RC base API URL
    rc_client_Id: process.env.RINGCENTRAL_CLIENT_ID,
    rc_authorize_uri: process.env.RINGCENTRAL_AUTHORIZE_URI,
    rc_jwks_url: process.env.JWKS_URL,
    jwksAppName: {
        production: process.env.JWKS_APP_NAME,
        sandBox: process.env.JWKS_SANDBOX_APPNAME,
    },
};

module.exports = config;
